import Vue from 'vue'
import { mapState } from 'vuex'
import BigNumber from 'bignumber.js'
import { JobApplicationStatuses } from '@/constants/job/jobApplicationStatuses'
import { JobOfferStages } from '@/constants/job/jobOfferStages'
import rolebleMixin from '@/mixins/rolebleMixin'
import snackMixin from '@/mixins/snackMixin'
import { googleAnalyticsV2 } from '@/servicies-ts/analytics'
import { RootState } from '@/store'
import { formatUsd } from '@/utils/moneyFormat'
import { jobPartiesMixin, offerManageMixin, startableMixin } from '../mixins'

export default Vue.extend<any, any, any, any>({
  mixins: [jobPartiesMixin, offerManageMixin, rolebleMixin, startableMixin, snackMixin],
  computed: {
    ...mapState<RootState>({
      application: (state: any) => state.jobChat.application.value,
    }),
    appOffer() {
      return this.application.offer
    },
    isArchived() {
      return this.application.status === JobApplicationStatuses.ARCHIVED
    },
    isNewOffer() {
      return this.appOffer?.stage === JobOfferStages.NEW
    },
    deadline() {
      return `${this.appOffer?.deadlineInDays} days delivery`
    },
    budget() {
      return formatUsd(new BigNumber(this.appOffer?.budget))
    },
    hasActionsBtn() {
      return this.appOffer?.stage === JobOfferStages.NEW
    },
  },
  methods: {
    async onCancelOfferByCustomerClick() {
      try {
        this.declining = true
        googleAnalyticsV2.send({
          event: 'response-to-job',
          'event-content': 'customer-button-click-decline-offer',
          job_id: this.application.job.id,
        })
        await this.cancelOffer()
      } finally {
        this.declining = false
      }
    },
    async onCancelOfferByFreelancerClick() {
      try {
        this.declining = true
        await this.cancelOffer()
      } finally {
        this.declining = false
      }
    },
    async onEditOfferClick() {
      this.editOffer()
    },
    async onAcceptClick() {
      this.acceptOffer()
    },
  },
})
